<template>
    <div>
        <base-input
            v-model="form.name"
            validate="required"
            name="name"
            label="Name"
            placeholder="Enter space name"/>

        <base-text-area
            v-model="form.description"
            name="description"
            label="Description"
            placeholder="Space description"/>

        <base-button
            :loading="update.loading"
            icon="fas fa-check"
            @click="submit"
            class="is-primary"
            text="Save"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { copy } from '../../utils/helpers';

export default {
    name: 'SpaceSettingsGeneral',
    props: ['space'],
    computed: mapState('spaces', ['update']),
    data() {
        return { form: copy(this.space) };
    },
    methods: {
        submit() {
            this.$store.dispatch('spaces/update', {
                space_id: this.space.id,
                data: { name: this.form.name, description: this.form.description },
            });
        },
    },
};
</script>
